export default __webpack_public_path__ + "static/media/shopify-step-2.6ddcce72.png";